export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // white
  MAIN_COLOR: '#4676BA', // blue pritchards
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#42C6F3', // light blue
  SECONDARY_COLOR: '#42C6F3',
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
